import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import { toastError } from '@components/Toast';

import SingleSampleItem from '@features/buyer-request/components/sample/SingleSampleItem';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import ApiClient from '@lib/apiClient';

import { _getKey, STATIC_SET_CONSTANTS } from '@utils/Util';

const setColorResponse = (colorList = []) => {
	let list = [];
	if (colorList?.length === 0) {
		list.push({
			key: _getKey(),
			code: '',
			name: '',
			hexCode: null,
			pantoneColorId: null,
			size: null,
			quantity: null
		});
	} else {
		list = colorList.map((item) => {
			return {
				...item,
				code: item?.colorResponse?.name || '',
				key: _getKey(),
				size: item?.size || null,
				quantity: item?.quantity || null
			};
		});
	}
	let listLength = list.length;
	for (let i = listLength; i < 4; i++) {
		list.push({
			key: _getKey(),
			code: '',
			hexCode: null,
			pantoneColorId: null,
			size: null,
			quantity: null
		});
	}
	return list;
};

const SampleRequestDetails = () => {
	const [sampleInfo, setSampleInfo] = useState(null);
	const { id } = useParams();
	const dispatch = useDispatch();

	const isProductHasSet = (product) => {
		return product.isSet || product.setPackStyleFlag === STATIC_SET_CONSTANTS.SET_PRODUCT;
	};

	const fetchSampleDetails = () => {
		dispatch(openLoader());
		ApiClient.GET('sampleDetailsAction', id)
			.then(({ data }) => {
				let sampleRequestItemResponseList = data?.sampleRequestItemResponseList?.map((item) => {
					if (isProductHasSet(item)) {
						return {
							...item,
							setMemberSampleRequestItemResponseList:
								item?.setMemberSampleRequestItemResponseList.map((member) => {
									return {
										...member,
										sampleItemDetailsResponseList: setColorResponse(
											member?.sampleItemDetailsResponseList
										)
									};
								})
						};
					} else {
						return {
							...item,
							sampleItemDetailsResponseList: setColorResponse(
								item?.sampleItemDetailsResponseList
							)
						};
					}
				});
				setSampleInfo({ ...data, sampleRequestItemResponseList: sampleRequestItemResponseList });
				dispatch(closeLoader());
			})
			.catch((error) => {
				toastError(error.response.data.message);
				dispatch(closeLoader());
			});
	};

	useEffect(() => {
		fetchSampleDetails();
	}, [id]);

	return (
		<div className="sample-dashboard-container on-sample-request px-4">
			<SingleSampleItem
				sampleData={sampleInfo}
				cardType="SAMPLE_VIEW"
				isBuyerRequest={true}
				setSampleInfo={setSampleInfo}
				fetchSampleDetails={fetchSampleDetails}
			/>
		</div>
	);
};

export default SampleRequestDetails;
